import React from "react";
import { Form } from "react-bootstrap";

const CompanySection = (props) => {
  const businessUnit = JSON.parse(sessionStorage.getItem("businessUnit"));

  return (
    <div>
      Company
      <Form.Select
        as="select"
        placeholder="Enter User Business Unit"
        custom
        onChange={props.updateBusinessUnit}
        style={{ width: "250px" }}
      >
        <option>Click Here For Options</option>
        {props.businessUnitsList &&
          (businessUnit.businessUnitName === "CWM Home Office" ||
          businessUnit.businessUnitName === "City Wide Maintenance (root)" ||
          businessUnit.businessUnitName === "National Business Development"
            ? [...props.businessUnitsList, "Support Center"]
            : props.businessUnitsList
          )
            .sort((x, y) => x.toString().toLowerCase().localeCompare(y))
            .map((businessUnit) => {
              return <option key={businessUnit}>{businessUnit}</option>;
            })}
      </Form.Select>
    </div>
  );
};

export default CompanySection;
